import React, { useEffect } from 'react';
import Button from '../../components/Button';
import { useCarousel } from './Carousel';
import styles from './CarouselControls.module.scss';
import SVGIcon from '../../components/SVGIcon';
import caretIcon from '../../icons/caret.svg';

interface CarouselControlsProps {
  arrowKeysEnabled?: boolean;
}

const CarouselControls = ({ arrowKeysEnabled }: CarouselControlsProps) => {
  const { dispatch, currentIndex, length } = useCarousel();

  useEffect(() => {
    if (!arrowKeysEnabled) return undefined;

    function onKeyDown(e: KeyboardEvent) {
      if (e.key === 'ArrowLeft') dispatch({ type: 'step', by: -1 });
      if (e.key === 'ArrowRight') dispatch({ type: 'step', by: 1 });
    }

    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [dispatch, arrowKeysEnabled]);

  return (
    <div className={styles.container}>
      <Button
        className={styles.button}
        onClick={() => dispatch({ type: 'step', by: -1 })}
        testId="carouselControlPrevious"
      >
        <SVGIcon size={10} className={styles.left}>
          {caretIcon}
        </SVGIcon>
      </Button>
      <div className={styles.pagination}>
        {currentIndex + 1} / {length}
      </div>
      <Button
        className={styles.button}
        onClick={() => dispatch({ type: 'step', by: 1 })}
        testId="carouselControlNext"
      >
        <SVGIcon size={10} className={styles.right}>
          {caretIcon}
        </SVGIcon>
      </Button>
    </div>
  );
};

export default CarouselControls;
